import { useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import type { AppVersionCheckParams } from '../types/appVersionCheck.types';
import { toFilterValues, toSearchFilters } from '../utils/appVersionCheckFilters';

const route = getRouteApi('/_auth/reports/app-version-check');

export function useAppVersionCheckFilters() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const appliedValues = useMemo(() => toFilterValues(search), [search]);
  const reportParams = useMemo<AppVersionCheckParams>(() => ({ ...search }), [search]);

  const filters = useUrlSyncedFilters({
    appliedValues,
    shouldWaitForApply: true,
    onApply: (values) => {
      void navigate({ search: toSearchFilters(values), replace: true });
    },
  });

  return { ...filters, reportParams };
}
